import { makeActionCreator } from '../../../../utilities'
import { DrainConstants } from './drain.constants'

export const setDate = makeActionCreator(DrainConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(DrainConstants.SET_TIME, 'time')
export const setRolePerforming = makeActionCreator(DrainConstants.SET_ROLE_PERFORMING, 'rolePerforming')

export const setProcedureComplications = makeActionCreator(
  DrainConstants.SET_PROCEDURE_COMPLICATIONS,
  'procedureComplications'
)
export const setResponse = makeActionCreator(DrainConstants.SET_RESPONSE, 'response')
export const setAuthorization = makeActionCreator(DrainConstants.SET_AUTHORIZATION, 'authorization')
export const setComments = makeActionCreator(DrainConstants.SET_COMMENTS, 'comments')
export const setType = makeActionCreator(DrainConstants.SET_TYPE, 'type')
export const setSuccessful = makeActionCreator(DrainConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(DrainConstants.SET_ATTEMPTS, 'attempts')
export const setAction = makeActionCreator(DrainConstants.SET_ACTION, 'action')
export const setProcedure = makeActionCreator(DrainConstants.SET_PROCEDURE, 'procedure')
export const setSize = makeActionCreator(DrainConstants.SET_SIZE, 'size')
export const setSizeUnit = makeActionCreator(DrainConstants.SET_SIZE_UNIT, 'sizeUnit')
export const setDrainSuction = makeActionCreator(DrainConstants.SET_DRAIN_SUCTION, 'drainSuction')
export const setChestSuction = makeActionCreator(DrainConstants.SET_CHEST_SUCTION, 'chestSuction')
export const setFoleyColor = makeActionCreator(DrainConstants.SET_FOLEY_COLOR, 'foleyColor')
export const setCsfColor = makeActionCreator(DrainConstants.SET_CSF_COLOR, 'csfColor')
export const setCapped = makeActionCreator(DrainConstants.SET_CAPPED, 'capped')
export const setSide = makeActionCreator(DrainConstants.SET_SIDE, 'side')
export const setLocation = makeActionCreator(DrainConstants.SET_LOCATION, 'location')
export const setIntercostalSpace = makeActionCreator(DrainConstants.SET_INTERCOSTAL_SPACE, 'intercostalSpace')
export const setDepth = makeActionCreator(DrainConstants.SET_DEPTH, 'depth')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  DrainConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
export const setDateTime = makeActionCreator(DrainConstants.SET_DATE_TIME, 'time', 'date')
export const setUpdateInputRows = makeActionCreator(DrainConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setAddToTimeLine = makeActionCreator(DrainConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setDrainState = makeActionCreator(DrainConstants.SET_STATE, 'drainState')
export const setField2 = makeActionCreator(DrainConstants.SET_FIELD2, 'field2')
export const saveDrain = makeActionCreator(DrainConstants.SAVE_DRAIN)
export const onSelectDrainProcedure = makeActionCreator(DrainConstants.ON_SELECT_DRAIN)
export const setDrainDefaults = makeActionCreator(DrainConstants.SET_DRAIN_DEFAULTS, 'drainDefaults')
export const resetToInitialState = makeActionCreator(DrainConstants.RESET_TO_INITIAL_STATE)
export const resetState = makeActionCreator(DrainConstants.RESET_STATE)
